import React from 'react'

import Grid from '../../../../components/Grid'
import CertsAndAppsAreaItem from './CertsAndAppsAreaItem'
import { itemExistsInLocale } from '../../utils'
import { apps as _apps, certificates as _certs } from './data'

import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

const CertsAndAppArea: React.FC<{
  locale: ELocale
  certificates?: TItem[]
  apps?: TItem[]
}> = (props) => {
  const { locale, certificates = _certs, apps = _apps } = props
  return (
    <Grid.Container className="mt-32">
      <Grid.Row>
        <Grid.Col width={12} sm={6}>
          <p className="mb-16 text-center font-bold sm:text-left">Sicher einkaufen</p>
          <Grid.Row as="ul" className="justify-around flex-nowrap sm:justify-start">
            {certificates
              .filter((it) => itemExistsInLocale(it, locale))
              .map((item, index) => (
                <CertsAndAppsAreaItem key={item.label} item={item} index={index} type={'cert'} />
              ))}
          </Grid.Row>
        </Grid.Col>
        <Grid.Col width={12} sm={6} className="mt-24 sm:mt-0">
          {locale != ELocale.DE_CH && <p className="mb-16 font-bold text-center sm:text-left">HSE App</p>}
          <Grid.Row as="ul" className="justify-around flex-nowrap sm:justify-start">
            {apps.map(
              (item, index) =>
                itemExistsInLocale(item, locale) && (
                  <CertsAndAppsAreaItem key={item.label} item={item} index={index} type={'app'} />
                ),
            )}
          </Grid.Row>
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  )
}

export { CertsAndAppArea as default }
